var map = {
	"./branding": 58,
	"./branding.js": 58,
	"./enershare/enershare-functions": 608,
	"./enershare/enershare-functions.js": 608,
	"./enershare/enershare-values": 609,
	"./enershare/enershare-values.js": 609,
	"./enershare/img/logo_Enershare.svg": 450,
	"./enershare/img/logo_Enershare_Icon.svg": 1043,
	"./opalrt/img/datamodel.png": 1044,
	"./opalrt/img/eonerc_rwth.svg": 606,
	"./opalrt/img/logo_opalrt.svg": 605,
	"./opalrt/img/logo_opalrt_square.svg": 1045,
	"./opalrt/opalrt-functions": 233,
	"./opalrt/opalrt-functions.js": 233,
	"./opalrt/opalrt-values": 369,
	"./opalrt/opalrt-values.js": 369,
	"./slew/img/eonerc_rwth.svg": 602,
	"./slew/img/erigrid2.png": 603,
	"./slew/img/european_commission.svg": 604,
	"./slew/img/slew_blue.svg": 1046,
	"./slew/img/slew_logo.png": 1047,
	"./slew/img/slew_magenta.svg": 1048,
	"./slew/slew-functions": 298,
	"./slew/slew-functions.js": 298,
	"./slew/slew-values": 368,
	"./slew/slew-values.js": 368,
	"./slew/slew.css": 601,
	"./template/img/template_logo.svg": 607,
	"./template/template-functions": 234,
	"./template/template-functions.js": 234,
	"./template/template-values": 370,
	"./template/template-values.js": 370,
	"./villasweb/img/datamodel.png": 1049,
	"./villasweb/img/eonerc_rwth.svg": 596,
	"./villasweb/img/erigrid2.png": 600,
	"./villasweb/img/european_commission.svg": 449,
	"./villasweb/img/jara.svg": 1050,
	"./villasweb/img/reserve.svg": 599,
	"./villasweb/img/uel.png": 598,
	"./villasweb/img/uel_efre.jpeg": 597,
	"./villasweb/img/villas_web.svg": 595,
	"./villasweb/villasweb-functions": 192,
	"./villasweb/villasweb-functions.js": 192,
	"./villasweb/villasweb-values": 297,
	"./villasweb/villasweb-values.js": 297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;